import { MasterAction, MasterActionTypes } from './master.actions';

export const MASTER_FEATURE_KEY = 'master';

/**
 * Interface for the 'Master' data used in
 *  - MasterState, and the reducer function
 *
 *  Note: replace if already defined in another module
 */

/* tslint:disable:no-empty-interface */
export interface clientDetails {
  id: string;
  name: string;
  address01: string;
  address02: string;
  address03: string;
  address04: string;
  createdAt: string;
  updatedAt: string;
  owner: string;
}

export interface MasterState {
  list: any; // list of Master; analogous to a sql normalized table
  selectedId?: string | number; // which Master record has been selected
  loaded: boolean; // has the Master list been loaded
  error?: any; // last none error (if any)
  shipper?: clientDetails[];
  consignee?: clientDetails[];
  notify?: clientDetails[];
  deliveryAgent?: clientDetails[];
  airportCode?: { id: string; code: string }[];
  carrierCode?: { id: string; code: string }[];
  destinationAirport?: { id: string; name: string }[];
  airline?: { id: string; name: string }[];
  loading?: boolean;
  entityDeleteLoading?: boolean;
}

export interface MasterPartialState {
  readonly [MASTER_FEATURE_KEY]: MasterState;
}

export const initialState: MasterState = {
  list: [],
  loaded: false,
};

export function reducer(
  state: MasterState = initialState,
  action: MasterAction
): MasterState {
  switch (action.type) {
    case MasterActionTypes.MasterLoaded: {
      state = {
        ...state,
        list: action.payload,
        loaded: true,
      };
      break;
    }
    case MasterActionTypes.CreateShipper: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.ShipperCreated: {
      state = {
        ...state,
        loading: false,
        shipper: [...state.shipper, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateShipperError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    case MasterActionTypes.LoadShipper: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.ShipperLoaded: {
      state = {
        ...state,
        loading: false,
        shipper: action.payload,
      };
      break;
    }
    case MasterActionTypes.ShipperLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.UpdateShipper: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.ShipperUpdated: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.UpdateShipperError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.ClearStore: {
      state = {
        ...state,
        shipper: null,
        consignee: null,
        notify: null,
        deliveryAgent: null,
      };
      break;
    }
    case MasterActionTypes.CreateConsignee: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.ConsigneeCreated: {
      state = {
        ...state,
        loading: false,
        consignee: [...state.consignee, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateConsigneeError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadConsignee: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.ConsigneeLoaded: {
      state = {
        ...state,
        loading: false,
        consignee: action.payload,
      };
      break;
    }
    case MasterActionTypes.ConsigneeLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.UpdateConsignee: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.ConsigneeUpdated: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.UpdateConsigneeError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.CreateNotify: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.NotifyCreated: {
      state = {
        ...state,
        loading: false,
        notify: [...state.notify, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateNotifyError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadNotify: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.NotifyLoaded: {
      state = {
        ...state,
        loading: false,
        notify: action.payload,
      };
      break;
    }
    case MasterActionTypes.NotifyLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.UpdateNotify: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.NotifyUpdated: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.UpdateNotifyError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }

    case MasterActionTypes.CreateDeliveryAgent: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.DeliveryAgentCreated: {
      state = {
        ...state,
        loading: false,
        deliveryAgent: [...state.deliveryAgent, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateDeliveryAgentError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadDeliveryAgent: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.DeliveryAgentLoaded: {
      state = {
        ...state,
        loading: false,
        deliveryAgent: action.payload,
      };
      break;
    }
    case MasterActionTypes.DeliveryAgentLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.UpdateDeliveryAgent: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.DeliveryAgentUpdated: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.UpdateDeliveryAgentError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.CreateAirportCode: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.AirportCodeCreated: {
      state = {
        ...state,
        loading: false,
        airportCode: [...state.airportCode, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateAirportCodeError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadAirportCode: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.AirportCodeLoaded: {
      state = {
        ...state,
        loading: false,
        airportCode: action.payload,
      };
      break;
    }
    case MasterActionTypes.AirportCodeLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.CreateCarrierCode: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.CarrierCodeCreated: {
      state = {
        ...state,
        loading: false,
        carrierCode: [...state.carrierCode, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateCarrierCodeError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadCarrierCode: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.CarrierCodeLoaded: {
      state = {
        ...state,
        loading: false,
        carrierCode: action.payload,
      };
      break;
    }
    case MasterActionTypes.CarrierCodeLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.CreateDestinationAirport: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.DestinationAirportCreated: {
      state = {
        ...state,
        loading: false,
        destinationAirport: [...state.destinationAirport, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateDestinationAirportError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadDestinationAirport: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.DestinationAirportLoaded: {
      state = {
        ...state,
        loading: false,
        destinationAirport: action.payload,
      };
      break;
    }
    case MasterActionTypes.DestinationAirportLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.CreateAirline: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.AirlineCreated: {
      state = {
        ...state,
        loading: false,
        airline: [...state.airline, action.payload],
      };
      break;
    }
    case MasterActionTypes.CreateAirlineError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case MasterActionTypes.LoadAirline: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case MasterActionTypes.AirlineLoaded: {
      state = {
        ...state,
        loading: false,
        airline: action.payload,
      };
      break;
    }
    case MasterActionTypes.AirlineLoadError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case MasterActionTypes.DeleteEntity: {
      state = {
        ...state,
        entityDeleteLoading: true,
      };
      break;
    }
    case MasterActionTypes.EntityDeleted: {
      state = {
        ...state,
        entityDeleteLoading: false,
      };
      break;
    }
    case MasterActionTypes.DeleteEntityError: {
      state = {
        ...state,
        entityDeleteLoading: false,
      };
      break;
    }
  }
  return state;
}
